import React from 'react'
import './Popup.css'

const content = [
    {
        name: 'photo0',
        title: "Royce Hall aftermath",
        image: 'https://wp.dailybruin.com/images/2024/06/photo0.NG_.jpg',
        description: "Pieces of the barricade lie near the entrance of Royce Hall’s archway, covered in signage and graffiti. A section of the graffiti in white reads “ACAB,” an acronym for “All cops are bastards,” while another in green reads “Fuck Fascism.” On two sides of a pillar, graffiti in green says, “In the darkness and the dawn, a red star rises” – a reference to the concluding lines of a Langston Hughes poem about Bolshevik leader Vladimir Lenin.",
        byline: '(Nicolas Greamo/Daily Bruin senior staff)',
        date: '5/2',
        fulldate: 'May 2, 2024 7:15 a.m.',
        },
        {
        name: 'photo1',
        title: "Powell Library aftermath",
        image: 'https://wp.dailybruin.com/images/2024/06/photo1.NG_.jpg',
        description: "A large Palestinian flag lies on the ground in front of Powell Library. Around 5 a.m. May 2, a law enforcement officer removed the flag from its mount toward the center of the encampment and threw it in the direction of Royce Hall. The flag rests beside the scattered remains of the encampment, sprawling out between the two hallmark buildings of UCLA’s campus.",
        byline: '(Nicolas Greamo/Daily Bruin senior staff)',
        date: '5/2',
        fulldate: 'May 2, 2024 7:17 a.m.',
        },
        {
        name: 'photo2',
        title: "Defusing tensions",
        image: 'https://wp.dailybruin.com/images/2024/06/photo2.ZI_.jpg',
        description: "An individual walks between members of the encampment and counter-protester groups in an attempt to defuse the tension and stave off fighting.",
        byline: '(Zoraiz Irshad/Daily Bruin senior staff)',
        date: '5/1',
        fulldate: 'May 1, 2024 2:01 a.m.',
        },
        {
        name: 'photo3',
        title: "Encampment press conference",
        image: 'https://wp.dailybruin.com/images/2024/06/photo3.BJM_.jpg',
        description: "With the towers of Royce Hall in the background, protesters hold Palestinian flags and signs up. The protesters appeared at the top of Janss Steps during a press conference held by the encampment at 3 p.m. May 1.",
        byline: '(Brandon Morquecho/Daily Bruin senior staff)',
        date: '5/1',
        fulldate: 'May 1, 2024 7:53 p.m.',
        },
        {
        name: 'photo4',
        title: "California Highway Patrol removes encampment barriers",
        image: 'https://wp.dailybruin.com/images/2024/06/photo4.ZI_.jpg',
        description: "A division of California Highway Patrol uses tools to cut through the ropes and zip ties holding together the metal barricades around the encampment, preparing for the ensuing sweep.",
        byline: '(Zoraiz Irshad/Daily Bruin senior staff)',
        date: '5/2',
        fulldate: 'May 2, 2024 3:11 a.m.',
        },
        {
        name: 'photo5',
        title: "Early stages of encampment",
        image: 'https://wp.dailybruin.com/images/2024/06/photo5.NG_.jpg',
        description: "A view from above the encampment April 26 shows two sprawling groups of tents separated by a walkway and surrounded by wooden barricades and metal fencing.",
        byline: '(Nicolas Greamo/Daily Bruin senior staff)',
        date: '4/26',
        fulldate: 'April 26, 2024 6:16 p.m.',
        },
        {
        name: 'photo6',
        title: "Law enforcement and protester standoff",
        image: 'https://wp.dailybruin.com/images/2024/06/photo6.BJM_.jpg',
        description: "Police officers wearing riot gear between Royce Hall and Rolfe Hall stand facing a large group of protesters. Law enforcement cleared the Palestine solidarity encampment at UCLA in the early hours of May 2 after a dispersal order was issued.",
        byline: '(Brandon Morquecho/Daily Bruin senior staff)',
        date: '5/1',
        fulldate: 'May 1, 2024 10:10 p.m.',
        },
        {
        name: 'photo7',
        title: "Counter-protester climbs fence",
        image: 'https://wp.dailybruin.com/images/2024/06/photo7.JCC_.jpg',
        description: "A counter-protester attempts to breach a fence outside the encampment in Dickson Plaza in the early hours of April 28. The fence was placed the night of April 25 by security in front of the encampment – which was organized by Students for Justice in Palestine and the UC Divest Coalition at UCLA.",
        byline: '(Joseph Crosby/Daily Bruin senior staff)',
        date: '4/28',
        fulldate: 'April 28, 2024 12:10 a.m.',
        },
        {
        name: 'photo8',
        title: "Encampment cleanup",
        image: 'https://wp.dailybruin.com/images/2024/06/photo8.JC_.jpg',
        description: "UCLA staff cleared Dickson Plaza of debris using excavators and other heavy machinery following the May 2 police sweep of the Palestine solidarity encampment.",
        byline: '(Jeremy Chen/Daily Bruin senior staff)',
        date: '5/2',
        fulldate: 'May 2, 2024 11:14 a.m.',
        },
        {
        name: 'photo9',
        title: "Pro-Palestine protester chanting",
        image: 'https://wp.dailybruin.com/images/2024/06/photo9.MF_.jpg',
        description: "A pro-Palestine protester chants at the top of Janss Steps after a group of police officers initially retreated from the encampment.",
        byline: '(Myka Fromm/Daily Bruin senior staff)',
        date: '5/2',
        fulldate: 'May 2, 2024',
        },
        {
        name: 'photo10',
        title: "Los Angeles County Sheriff’s Department buses transport detained protesters",
        image: 'https://wp.dailybruin.com/images/2024/06/photo10.NG_.jpg',
        description: "Law enforcement officers from the Los Angeles County Sheriff’s Department and California Highway Patrol gather near a bus being used to transport detained protesters after the sweep of the encampment the morning of May 2.",
        byline: '(Nicolas Greamo/Daily Bruin senior staff)',
        date: '5/2',
        fulldate: 'May 2, 2024 7:41 a.m.',
        },
        {
        name: 'photo11',
        title: "California Highway Patrol officers blocking pathway",
        image: 'https://wp.dailybruin.com/images/2024/06/photo11.BJM_.jpg',
        description: "A man wearing a jacket that reads “Anti Genocide Social Club” records a livestream of a line of California Highway Patrol officers between Royce Hall and Haines Hall. The line of officers ordered a clearing of the area and threatened to arrest three Daily Bruin reporters.",
        byline: '(Brandon Morquecho/Daily Bruin senior staff)',
        date: '5/2',
        fulldate: 'May 2, 2024',
        },
        {
        name: 'photo12',
        title: "Jum'ah prayer",
        image: 'https://wp.dailybruin.com/images/2024/06/photo12.AGS_.jpg',
        description: "Some protesters in the Dickson Plaza encampment participate in Jum'ah prayer while other members of the protest forme a circle around those praying.",
        byline: '(Aidan Sun/Assistant Photo editor)',
        date: '4/26',
        fulldate: 'April 26, 2024 1:21 p.m.',
        },
        {
        name: 'photo13',
        title: "Palestine solidarity encampment banner",
        image: 'https://wp.dailybruin.com/images/2024/06/photo13.DS_-1.jpg',
        description: "A banner that reads “Palestine Solidarity Encampment” features a watermelon and stands across from a food and necessities tent. The watermelon has become an unofficial symbol of protest for Palestine supporters, representing defiance and resistance against the occupation of Palestine.",
        byline: '(Darlene Sanzon/Assistant Photo editor)',
        date: '4/25',
        fulldate: 'April 25, 2024 10:27 a.m.',
        },
        {
        name: 'photo14',
        title: "Encampment posters ",
        image: 'https://wp.dailybruin.com/images/2024/06/photo14.AGS_-1.jpg',
        description: "Protesters place homemade signs with pro-Palestine slogans around a second layer of metal fencing, which was erected by UCLA officials the morning of April 26 after they constructed an initial layer the night of April 25.",
        byline: '(Aidan Sun/Assistant Photo editor)',
        date: '4/26',
        fulldate: 'April 26, 2024 1:00 p.m.',
        },
        {
        name: 'photo15',
        title: "Dickson Plaza solidarity circle",
        image: 'https://wp.dailybruin.com/images/2024/06/photo15.JZH_.jpg',
        description: "Protesters encircle Dickson Plaza with arms intertwined in a display of solidarity.",
        byline: '(Julia Zhou/Daily Bruin senior staff)',
        date: '4/25',
        fulldate: 'April 25, 2024 6:30 p.m.',
        },
        {
        name: 'photo16',
        title: "Counter-protesters gather at Royce Hall",
        image: 'https://wp.dailybruin.com/images/2024/06/photo16.JZH_.jpg',
        description: "Counter-protesters gather in front of Royce Hall the afternoon of April 25. The counter-protesters and protesters, separated by Contemporary Services Corporation security officers, confronted each other at Dickson Plaza.",
        byline: '(Julia Zhou/Daily Bruin senior staff)',
        date: '4/25',
        fulldate: 'April 25, 2024 6:45 p.m.',
        },
        {
        name: 'photo17',
        title: "Pro-Israel rally stage",
        image: 'https://wp.dailybruin.com/images/2024/06/photo17.ZI_.jpg',
        description: "Following a musical performance at the pro-Israel rally – which was organized in response to the encampment – a singer shares an embrace with another event speaker.",
        byline: '(Zoraiz Irshad/Daily Bruin senior staff)',
        date: '4/28',
        fulldate: 'April 28, 2024 12:29 p.m.',
        },
        {
        name: 'photo18',
        title: "Pro-Israel protester rips poster",
        image: 'https://wp.dailybruin.com/images/2024/06/photo18.SS_.jpg',
        description: "A crowd watches a counter-protester use a switchblade to rip through a poster displaying support for Palestine during a rally led by the Israeli American Council on April 28.",
        byline: '(Sharla Steinman/Daily Bruin senior staff)',
        date: '4/28',
        fulldate: 'April 28, 2024 12:59 p.m.',
        },
        {
        name: 'photo19',
        title: "Demonstrators waving Palestinian flag",
        image: 'https://wp.dailybruin.com/images/2024/06/photo19.JC_.jpg',
        description: "Pro-Palestine demonstrators wave a large Palestinian flag on Portola Plaza after a pro-Israel rally April 28.",
        byline: '(Jeremy Chen/Daily Bruin senior staff)',
        date: '4/28',
        fulldate: 'April 28, 2024 12:17 p.m.',
        },
        {
        name: 'photo20',
        title: "Setting up the encampment",
        image: 'https://wp.dailybruin.com/images/2024/06/photo20.DS_.jpg',
        description: "Following the spread of student-organized encampments across the country, UCLA students in support of Palestine establish a Palestine solidarity encampment the morning of April 25. The encampment, which lasted just over a wees, was filled with tents and surrounded by wooden and metal barricades.",
        byline: '(Darlene Sanzon/Assistant Photo editor)',
        date: '4/25',
        fulldate: 'April 25, 2024 9:43 p.m.',
        },
        {
        name: 'photo21',
        title: "Faculty and staff solidarity",
        image: 'https://wp.dailybruin.com/images/2024/06/photo21.DS_.jpg',
        description: "UCLA faculty and staff members join the encampment alongside students, while others offered solidarity. UCLA academic workers from United Auto Workers Local 4811 went on strike May 28 after the union filed unfair labor practice charges against the UC. ",
        byline: '(Darlene Sanzon/Assistant Photo editor)',
        date: '4/25',
        fulldate: 'April 25, 2024 9:56 a.m.',
        },
        {
        name: 'photo22',
        title: "Barrier decorations",
        image: 'https://wp.dailybruin.com/images/2024/06/photo22.MT_.jpg',
        description: "Pro-Palestine demonstrators set up the encampment in Dickson Plaza between Royce Hall and Powell Library. The eastern wall of the encampment was decorated with posters and a banner with \"UCLA Law says Free Palestine\" printed on it.",
        byline: '(Mia Tavares/Daily Bruin senior staff)',
        date: '4/25',
        fulldate: 'April 25, 2024 8:42 a.m.',
        },
        {
        name: 'photo23',
        title: "Palestinian flags on Powell Library",
        image: 'https://wp.dailybruin.com/images/2024/06/photo23.MT_.jpg',
        description: "Hours after the encampment was first established, the scaffolding surrounding Powell Library's front entrance is decorated with Palestinian flags, posters and graffiti. On Thursday morning, UCLA administration restricted access to Powell Library and Royce Hall to those with BruinCards.",
        byline: '(Mia Tavares/Daily Bruin senior staff)',
        date: '4/25',
        fulldate: 'April 25, 2024 8:44 a.m.',
        },
        {
        name: 'photo24',
        title: "Encampment growing",
        image: 'https://wp.dailybruin.com/images/2024/06/photo24.MT_.jpg',
        description: "Students for Justice in Palestine at UCLA called upon UCLA students to join the encampment on Instagram. The organization urged the UC to divest from companies \"complicit in the Israeli occupation, apartheid, and genocide\" of Palestinians, disclose the UC's and UCLA Foundation's assets, sever ties with LAPD, call for an immediate and permanent ceasefire in the Gaza Strip, and boycott Israeli academic institutions.",
        byline: '(Mia Tavares/Daily Bruin senior staff)',
        date: '4/25',
        fulldate: 'April 25, 2024 8:43 a.m.',
        },
        {
        name: 'photo25',
        title: "Instructional boards",
        image: 'https://wp.dailybruin.com/images/2024/06/photo25.MT_.jpg',
        description: "Demonstrators put up several large wooden boards around the encampment that detail Palestine's history. Inside the encampment, organizers invited guests to hold teach-ins providing information related to the Palestinian cause.",
        byline: '(Mia Tavares/Daily Bruin senior staff)',
        date: '4/25',
        fulldate: 'April 25, 2024 8:58 a.m.',
        },
        {
        name: 'photo26',
        title: "Large presence at encampment",
        image: 'https://wp.dailybruin.com/images/2024/06/photo26.ADL_.jpg',
        description: "At its peak on the first day of the encampment, nearly 300 attendees were present. Around 100 people slept in Dickson Plaza overnight inside tents or on the lawn.",
        byline: '(Anna Dai-Liu/Daily Bruin senior staff)',
        date: '4/25',
        fulldate: 'April 25, 2024 1:18 p.m.',
        },
        {
        name: 'photo27',
        title: "Physical confrontations by counter-protesters",
        image: 'https://wp.dailybruin.com/images/2024/06/photo27.JZH_.jpg',
        description: "Counter-protesters demonstrating against the Palestine solidarity encampment spent the first day waving Israeli flags and shouting insults at members of the encampment. At least one counter-protester entered the encampment and confronted its members. Over the course of the day, a few counter-protesters instigated physical confrontations with pro-Palestine demonstrators.",
        byline: '(Julia Zhou/Daily Bruin senior staff)',
        date: '4/25',
        fulldate: 'April 25, 2024 5:35 p.m.',
        },
        {
        name: 'photo28',
        title: "Injured protester receives medical treatment",
        image: 'https://wp.dailybruin.com/images/2024/06/photo30.ZL_.jpg',
        description: "Following physical confrontations between counter-protesters and members of the encampment during the first evening, a pro-Palestine protester receives medical treatment for an ankle injury and was carried away from Dickson Plaza around 9 p.m.",
        byline: '(Zimo Li/Photo Editor)',
        date: '4/25',
        fulldate: 'April 25, 2024 8:55 p.m.',
        },
        {
        name: 'photo29',
        title: "Establishing emergency exits",
        image: 'https://wp.dailybruin.com/images/2024/06/photo31.ZL_.jpg',
        description: "UCLA Fire Marshal Ricardo Barboza enters the encampment to discuss establishing emergency exits with organizers.",
        byline: '(Zimo Li/Photo Editor)',
        date: '4/25',
        fulldate: 'April 25, 2024 9:12 p.m.',
        },
        {
        name: 'photo30',
        title: "Putting up posters",
        image: 'https://wp.dailybruin.com/images/2024/06/photo33.AGS_.jpg',
        description: "Pro-Palestine protesters continue putting up posters outside the encampment on the second day. The encampment had an area dedicated to designing posters and banners that had a collection of art supplies.",
        byline: '(Aidan Sun/Assistant Photo editor)',
        date: '4/26',
        fulldate: 'April 26, 2024 12:57 p.m.',
        },
        {
        name: 'photo31',
        title: "Morning of day 2",
        image: 'https://wp.dailybruin.com/images/2024/06/photo34.DS_.jpg',
        description: "In response to the previous day's confrontations, UCLA officials set up two layers of metal barricades around the encampment. Overnight, some counter-protesters attempted to prevent those inside the encampment from sleeping by using a speaker to play loud music and shouting.",
        byline: '(Darlene Sanzon/Assistant Photo editor)',
        date: '4/26',
        fulldate: 'April 26, 2024 4:09 p.m.',
        },
        {
        name: 'photo32',
        title: "Passing the time",
        image: 'https://wp.dailybruin.com/images/2024/06/photo35.DS_.jpg',
        description: "Protesters inside the encampment play games and made posters to pass the time. The encampment organizers provided meals to attendees with the help of donations. ",
        byline: '(Darlene Sanzon/Assistant Photo editor)',
        date: '4/26',
        fulldate: 'April 26, 2024 4:13 p.m.',
        },
        {
        name: 'photo33',
        title: "Music in the encampment",
        image: 'https://wp.dailybruin.com/images/2024/06/photo36.DS_.jpg',
        description: "Demonstrators frequently played music inside the encampment. Many protesters wore keffiyehs, traditional Arab headscarfs popularized by Palestinian political figures such as Yasser Arafat, in solidarity with the Palestinian cause.",
        byline: '(Darlene Sanzon/Assistant Photo editor)',
        date: '4/26',
        fulldate: 'April 26, 2024 4:16 p.m.',
        },
        {
        name: 'photo34',
        title: "Encampment chants",
        image: 'https://wp.dailybruin.com/images/2024/06/photo37.DS_.jpg',
        description: "Pro-Palestine protesters spent much of their time repeating chants such as, \"Free, free Palestine.\" At times, these chants were met with competing ones from pro-Israel protesters, including \"Free the hostages.\"",
        byline: '(Darlene Sanzon/Assistant Photo editor)',
        date: '4/26',
        fulldate: 'April 26, 2024 4:56 p.m.',
        },
        {
        name: 'photo35',
        title: "CSC security separating protesters",
        image: 'https://wp.dailybruin.com/images/2024/06/photo38.DS_.jpg',
        description: "Pro-Israel counter-protesters continue to amass outside the encampment on the second day. CSC security officers hired by UCLA stood between the encampment and counter-protesters, using their bicycles to separate the two groups. ",
        byline: '(Darlene Sanzon/Assistant Photo editor)',
        date: '4/26',
        fulldate: 'April 26, 2024 5:12 p.m.',
        },
        {
        name: 'photo36',
        title: "Night of day two",
        image: 'https://wp.dailybruin.com/images/2024/06/photo39.JA_.jpg',
        description: "On the second night, hundreds of students sleep in Dickson Plaza, accessing the surrounding buildings to use the restroom. The encampment had access to a generator, which allowed students to charge their devices without having to leave.",
        byline: '(Jessica Allen/Daily Bruin)',
        date: '4/26',
        fulldate: 'April 26, 2024 10:32 p.m.',
        },
        {
        name: 'photo37',
        title: "Top view of encampment",
        image: 'https://wp.dailybruin.com/images/2024/06/photo40.LC_.jpg',
        description: "An above view of the encampment from Royce Hall shows the large number of tents that occupied the area, displaying the size of the encampment relative to Dickson Plaza.",
        byline: '(Leydi Cris Cobo Cordon/Daily Bruin senior staff)',
        date: '4/26',
        fulldate: 'April 26, 2024 3:17 p.m.',
        },
        {
        name: 'photo38',
        title: "Fortifying barriers",
        image: 'https://wp.dailybruin.com/images/2024/06/photo41.NG_.jpg',
        description: "Members of the encampment fortify the barriers using power tools and wooden pallets. ",
        byline: '(Nicolas Greamo/Daily Bruin senior staff)',
        date: '4/26',
        fulldate: 'April 26, 2024 8:44 p.m.',
        },
        {
        name: 'photo39',
        title: "Growing in numbers",
        image: 'https://wp.dailybruin.com/images/2024/06/photo42.DD_.jpg',
        description: "The encampment continued to grow in numbers on day three as people waited in line to enter the encampment.",
        byline: '(Dylan Du/Daily Bruin senior staff)',
        date: '4/27',
        fulldate: 'April 27, 2024 1:03 p.m.',
        },
        {
        name: 'photo40',
        title: "Counter-protesters by Royce Hall",
        image: 'https://wp.dailybruin.com/images/2024/06/photo43.ZI_.jpg',
        description: "Counter-protesters arrive around 11 p.m. with megaphones and large speakers and gather on the front steps of Royce Hall. They spelled out \"Bring them home\" using candles, referring to the Israeli hostages held by Palestinian political party and militant group Hamas since Oct. 7. The group of counter-protesters – some of whom said they were from Beverly Hills – peaked at around 30 people.",
        byline: '(Zoraiz Irshad/Daily Bruin senior staff)',
        date: '4/27',
        fulldate: 'April 27, 2024 11:04 p.m.',
        },
        {
        name: 'photo41',
        title: "Harassment of encampment",
        image: 'https://wp.dailybruin.com/images/2024/06/photo44.ZI_.jpg',
        description: "During the third night of the demonstration, counter-protesters continued to harass encampment participants, shout into megaphones and play loud music to prevent pro-Palestine protesters from sleeping. Meanwhile, encampment participants were peaceful and quiet as they continued their nightly routines.",
        byline: '(Zoraiz Irshad/Daily Bruin senior staff)',
        date: '4/27',
        fulldate: 'April 27, 2024 11:15 p.m.',
        },
        {
        name: 'photo42',
        title: "Encampment art station",
        image: 'https://wp.dailybruin.com/images/2024/06/photo45.ZI_.jpg',
        description: "Over the course of the encampment, protesters expressed their solidarity with Palestine and frustration with the UC through art. Organizers raised thousands of dollars through donations to help cover costs for food and supplies.",
        byline: '(Zoraiz Irshad/Daily Bruin senior staff)',
        date: '4/27',
        fulldate: 'April 27, 2024 7:21 p.m.',
        },
        {
        name: 'photo43',
        title: "Rented pickup trucks",
        image: 'https://wp.dailybruin.com/images/2024/06/photo46.ZI_.jpg',
        description: "Some members of the encampment rented pickup trucks to bring wooden pallets to fortify barriers. Demonstrators added protection throughout the week the encampment was present.",
        byline: '(Zoraiz Irshad/Daily Bruin senior staff)',
        date: '4/27',
        fulldate: 'April 27, 2024 10:37 p.m.',
        },
        {
        name: 'photo44',
        title: "Ambulances arrive",
        image: 'https://wp.dailybruin.com/images/2024/06/photo47.JSC_.jpg',
        description: "Following several 911 calls made by pro-Palestine protesters after multiple counter-protesters attempted to climb over barricades and push past demonstrators, ambulances and paramedics arrive on the scene.",
        byline: '(Joseph Crosby/Daily Bruin senior staff)',
        date: '4/28',
        fulldate: 'April 28, 2024 1:07 a.m.',
        },
        {
        name: 'photo45',
        title: "Security easing tensions",
        image: 'https://wp.dailybruin.com/images/2024/06/photo48.ZI_.jpg',
        description: "CSC security officers hired by UCLA attempt to ease tensions as multiple counter-protesters try to forcibly enter the encampment in the early morning April 28.",
        byline: '(Zoraiz Irshad/Daily Bruin senior staff)',
        date: '4/28',
        fulldate: 'April 28, 2024 12:10 a.m.',
        },
        {
        name: 'photo46',
        title: "Extending barriers",
        image: 'https://wp.dailybruin.com/images/2024/06/photo49.JSC_.jpg',
        description: "Encampment participants extend barriers up to the entrances of Powell Library and Royce Hall. The expanded area of the encampment stretched from the top of Janss Steps to the east end of Royce Hall. ",
        byline: '(Joseph Crosby/Daily Bruin senior staff)',
        date: '4/28',
        fulldate: 'April 28, 2024 2:32 a.m.',
        },
        {
        name: 'photo47',
        title: "Pro-Israel rally speeches",
        image: 'https://wp.dailybruin.com/images/2024/06/photo50.ADL_.jpg',
        description: "A woman speaks at the pro-Israel rally. The rally kicked off around 11 a.m. with musical performances and was followed by numerous speeches.",
        byline: '(Anna Dai-Liu/Daily Bruin senior staff)',
        date: '4/28',
        fulldate: 'April 28, 2024 11:48 a.m.',
        },
        {
        name: 'photo48',
        title: "Linking arms on Janss Steps",
        image: 'https://wp.dailybruin.com/images/2024/06/photo51.NG_.jpg',
        description: "Pro-Palestine protesters link arms near the top of Janss Steps, blocking access to the encampment. A group of counter-protesters had gathered at the foot of the steps around the same time.",
        byline: '(Nicolas Greamo/Daily Bruin senior staff)',
        date: '4/28',
        fulldate: 'April 28, 2024 12:10 p.m.',
        },
        {
        name: 'photo49',
        title: "UCPD dispersement after pro-Israel rally",
        image: 'https://wp.dailybruin.com/images/2024/06/photo52.BJM_.jpg',
        description: "As pro-Israel counter-protesters began to disperse at the end of the rally, they faced off with pro-Palestine protesters. UCPD officers in riot gear responded by lining up near the flagpole in Dickson Plaza, while pro-Palestine protesters assembled on Portola Plaza.",
        byline: '(Brandon Morquecho/Daily Bruin senior staff)',
        date: '4/28',
        fulldate: 'April 28, 2024 2:25 p.m.',
        },
        {
        name: 'photo50',
        title: "Protesters exchanging words",
        image: 'https://wp.dailybruin.com/images/2024/06/photo53.BJM_.jpg',
        description: "Lines of pro-Palestine and pro-Israel protesters stand feet apart, exchanging words and hurling insults.",
        byline: '(Brandon Morquecho/Daily Bruin senior staff)',
        date: '4/28',
        fulldate: 'April 28, 2024 2:30 p.m.',
        },
        {
        name: 'photo51',
        title: "UCPD and CSC separating protesters at pro-Israel rally",
        image: 'https://wp.dailybruin.com/images/2024/06/photo54.BJM_.jpg',
        description: "As UCPD and CSC security staff formed lines close to protesters in Portola Plaza, pro-Israel counter-protesters had mostly dispersed, while pro-Palestine protesters had migrated near the Inverted Fountain.",
        byline: '(Brandon Morquecho/Daily Bruin senior staff)',
        date: '4/28',
        fulldate: 'April 28, 2024 2:37 p.m.',
        },
        {
        name: 'photo52',
        title: "Pro-Palestine protesters walk across campus",
        image: 'https://wp.dailybruin.com/images/2024/06/photo55.BJM_.jpg',
        description: "After the rally, a large group of pro-Palestine protesters walsd through campus before stopping between Pauley Pavilion and the Central Ticket Office. ",
        byline: '(Brandon Morquecho/Daily Bruin senior staff)',
        date: '4/28',
        fulldate: 'April 28, 2024 2:49 p.m.',
        },
        {
        name: 'photo53',
        title: "Heated argument between protesters and security",
        image: 'https://wp.dailybruin.com/images/2024/06/photo56.BJM_.jpg',
        description: "A man with blood dripping from his temple approaches a CSC security staff member, shouting while pointing toward Powell Library. A few moments later, a group of pro-Israel counter-protesters approached to engage in the argument.",
        byline: '(Brandon Morquecho/Daily Bruin senior staff)',
        date: '4/28',
        fulldate: 'April 28, 2024 10:43 a.m.',
        },
        {
        name: 'photo54',
        title: "Pro-Israel rally speakers",
        image: 'https://wp.dailybruin.com/images/2024/06/photo57.BJM_.jpg',
        description: "After raising over $67,000 by the morning of April 28, the Israeli American Council holds a pro-Israel rally in Dickson Plaza, less than 100 yards from the encampment. IAC organizers invited speakers including Jonathan Greenblatt, CEO of the Anti-Defamation League, and Dan Gold, executive director of Hillel at UCLA.",
        byline: '(Brandon Morquecho/Daily Bruin senior staff)',
        date: '4/28',
        fulldate: 'April 28, 2024 11:56 a.m.',
        },
        {
        name: 'photo55',
        title: "Altercations at pro-Israel rally",
        image: 'https://wp.dailybruin.com/images/2024/06/photo58.BJM_.jpg',
        description: "Portions of the competing protests become tense as pro-Israel and pro-Palestine demonstrators confront each other.",
        byline: '(Brandon Morquecho/Daily Bruin senior staff)',
        date: '4/28',
        fulldate: 'April 28, 2024 12:14 p.m.',
        },
        {
        name: 'photo56',
        title: "Pro-Israel rally audience",
        image: 'https://wp.dailybruin.com/images/2024/06/photo59.BJM_.jpg',
        description: "The pro-Israel rally organized by the Israeli American Council attracted over a thousand counter-protesters. At 10:30 a.m., a group of demonstrators in support of the encampment pushed down the barriers surrounding the rally, which had been put up by UCPD and facilities staff, but later vacated the area.",
        byline: '(Brandon Morquecho/Daily Bruin senior staff)',
        date: '4/28',
        fulldate: 'April 28, 2024 12:33 p.m.',
        },
        {
        name: 'photo57',
        title: "Quiet from the encampment",
        image: 'https://wp.dailybruin.com/images/2024/06/photo60.NG_.jpg',
        description: "While the pro-Israel protesters assembled in Dickson Plaza, onlookers from inside the encampment remained peaceful for the entirety of the rally.",
        byline: '(Nicolas Greamo/Daily Bruin senior staff)',
        date: '4/28',
        fulldate: 'April 28, 2024 10:51 a.m.',
        },
        {
        name: 'photo58',
        title: "Chants in Bruin Plaza",
        image: 'https://wp.dailybruin.com/images/2024/06/photo61.ZL_.jpg',
        description: "Organizers in Bruin Plaza give speeches and lead chants such as, “What do we want? Justice. When do we want it? Now!”",
        byline: '(Zimo Li/Photo Editor)',
        date: '4/29',
        fulldate: 'April 29, 2024 12:45 p.m.',
        },
        {
        name: 'photo59',
        title: "Start of campus tour",
        image: 'https://wp.dailybruin.com/images/2024/06/photo62.ADL_.jpg',
        description: "Students, faculty and community members assemble near Bunche Hall before beginning their tour of campus shortly after noon.",
        byline: '(Anna Dai-Liu/Daily Bruin senior staff)',
        date: '4/29',
        fulldate: 'April 29, 2024 11:03 a.m.',
        },
        {
        name: 'photo60',
        title: "Expanding borders",
        image: 'https://wp.dailybruin.com/images/2024/06/photo63.KCF_.jpg',
        description: "After encampment participants expanded the area within their barriers in the early morning of April 28, the size of the encampment grew as more tents were set up.",
        byline: '(Karla Cardenas-Felipe/Daily Bruin)',
        date: '4/29',
        fulldate: 'April 29, 2024 12:40 p.m.',
        },
        {
        name: 'photo61',
        title: "Palestine solidarity rally",
        image: 'https://wp.dailybruin.com/images/2024/06/photo64.KCF_.jpg',
        description: "Protesters gather inside the encampment for a solidarity rally led by Faculty for Justice in Palestine and Students for Justice in Palestine at UCLA, where students and faculty members gave speeches calling on the UC to abide by the protesters' demands. ",
        byline: '(Karla Cardenas-Felipe/Daily Bruin)',
        date: '4/29',
        fulldate: 'April 29, 2024 12:49 p.m.',
        },
        {
        name: 'photo62',
        title: "Day five of encampment",
        image: 'https://wp.dailybruin.com/images/2024/06/photo65.KCF_.jpg',
        description: "On the fifth day of the encampment, thousands of faculty, students and community members came together to support the encampment. The protesters traveled through much of campus, starting near Bunche Hall before making their way to Bruin Plaza.",
        byline: '(Karla Cardenas-Felipe/Daily Bruin)',
        date: '4/29',
        fulldate: 'April 29, 2024 1:27 p.m.',
        },
        {
        name: 'photo63',
        title: "Large crowd in Bruin Plaza",
        image: 'https://wp.dailybruin.com/images/2024/06/photo66.KCF_.jpg',
        description: "In Bruin Plaza, over 1,000 participants gather around the stage to join chants led by members of Students for Justice in Palestine and the UC Divest Coalition at UCLA.",
        byline: '(Karla Cardenas-Felipe/Daily Bruin)',
        date: '4/29',
        fulldate: 'April 29, 2024 1:37 p.m.',
        },
        {
        name: 'photo64',
        title: "Making way through Royce Hall",
        image: 'https://wp.dailybruin.com/images/2024/06/photo67.LC_.jpg',
        description: "Hundreds of students force their way through Royce Hall's rear entrance before lining up under the archways in front of the building to hear speeches from inside the encampment.",
        byline: '(Leydi Cris Cobo Cordon/Daily Bruin senior staff)',
        date: '4/29',
        fulldate: 'April 29, 2024 12:57 p.m.',
        },
        {
        name: 'photo65',
        title: "Cheers for faculty in solidarity",
        image: 'https://wp.dailybruin.com/images/2024/06/photo68.MT_.jpg',
        description: "Faculty members make their way from Bunche Hall to the pathway between Kaplan Hall and Powell Library. Demonstrators inside the encampment cheered and applauded as faculty members were let inside.",
        byline: '(Mia Tavares/Daily Bruin senior staff)',
        date: '4/29',
        fulldate: 'April 29, 2024 2:08 p.m.',
        },
        {
        name: 'photo66',
        title: "Midnight fights",
        image: 'https://wp.dailybruin.com/images/2024/06/photo69.DW_.jpg',
        description: "Around 11 p.m., 30 counter-protesters arrived at Dickson Plaza and began harassing protesters inside the encampment. Less than an hour later, counter-protesters attempted to forcefully enter the entrance to the encampment between Powell Library and Kaplan Hall. Around midnight, UCPD officers wearing riot gear arrived at the scene, causing the 60 or so counter-protesters to vacate the area.",
        byline: '(Dylan Winward/Daily Bruin senior staff)',
        date: '4/29',
        fulldate: 'April 29, 2024 11:38 p.m.',
        },
        {
        name: 'photo67',
        title: "Counter-protesters wear white masks",
        image: 'https://wp.dailybruin.com/images/2024/06/photo70.ZI_.jpg',
        description: "On the evening of the encampment's sixth day, around 100 counter-protesters assemble in Dickson Plaza, with some wearing masks to protect their identity. ",
        byline: '(Zoraiz Irshad/Daily Bruin senior staff)',
        date: '4/30',
        fulldate: 'April 30, 2024 10:47 p.m.',
        },
        {
        name: 'photo68',
        title: "Upgraded barriers",
        image: 'https://wp.dailybruin.com/images/2024/06/photo72.ZI_.jpg',
        description: "Encampment participants made significant upgrades to the surrounding barriers ahead of the attack on the encampment. As counter-protesters violently attacked the encampment, members inside attempted to hold the barriers intact.",
        byline: '(Zoraiz Irshad/Daily Bruin senior staff)',
        date: '4/30',
        fulldate: 'April 30, 2024 10:52 p.m.',
        },
        {
        name: 'photo69',
        title: "Counter-protester spraying aerosol",
        image: 'https://wp.dailybruin.com/images/2024/06/photo73.ZI_.jpg',
        description: "A counter-protester dressed in black sprays an aerosol onto people inside the encampment. Throughout the night, counter-protesters sprayed noxious gasses at members of the encampent.",
        byline: '(Zoraiz Irshad/Daily Bruin senior staff)',
        date: '4/30',
        fulldate: 'April 30, 2024 10:56 p.m.',
        },
        {
        name: 'photo70',
        title: "Violent attacks by counter-protesters",
        image: 'https://wp.dailybruin.com/images/2024/06/photo74.ZI_.jpg',
        description: "During the night and early morning after parts of the barricade were torn down, counter-protesters attacked pro-Palestine protesters and threw objects at the encampment. By the end of the night, 25 protesters from the encampment were hospitalized, a spokesperson from UC Divest Coalition at UCLA said during a press conference the next day.",
        byline: '(Zoraiz Irshad/Daily Bruin senior staff)',
        date: '4/30',
        fulldate: 'April 30, 2024 11:07 p.m.',
        },
        {
        name: 'photo71',
        title: "911 calls",
        image: 'https://wp.dailybruin.com/images/2024/06/photo75.ZI_.jpg',
        description: "The acts of violence led to numerous calls to 911, prompting the arrival of emergency medical services. ",
        byline: '(Zoraiz Irshad/Daily Bruin senior staff)',
        date: '4/30',
        fulldate: 'April 30, 2024 11:16 p.m.',
        },
        {
        name: 'photo72',
        title: "Fireworks",
        image: 'https://wp.dailybruin.com/images/2024/06/photo76.ZI_.jpg',
        description: "Around 11 p.m., counter-protesters shot fireworks at the encampment. Throughout the night, counter-protesters released several fireworks.",
        byline: '(Zoraiz Irshad/Daily Bruin senior staff)',
        date: '4/30',
        fulldate: 'April 30, 2024 11:40 p.m.',
        },
        {
        name: 'photo73',
        title: "Firework exploding on barricade",
        image: 'https://wp.dailybruin.com/images/2024/06/photo77.file_.jpg',
        description: "A firework explodes at the base of the encampment barrier, creating a bright flash of light followed by a plume of smoke.",
        byline: '(Daily Bruin file photo)',
        date: '4/30',
        fulldate: 'April 30, 2024 11:02 p.m.',
        },
        {
        name: 'photo74',
        title: "Officers arrive",
        image: 'https://wp.dailybruin.com/images/2024/06/photo78.ZI_.jpg',
        description: "Around 1:50 a.m., a group of law enforcement officers assembled at the edge of Dickson Plaza near the flagpole. For an hour, officers stood watching the violence occur before slowly proceeding toward the encampment barricade.",
        byline: '(Zoraiz Irshad/Daily Bruin senior staff)',
        date: '5/1',
        fulldate: 'May 1, 2024 2:44 a.m.',
        },
        {
        name: 'photo75',
        title: "Gas masks",
        image: 'https://wp.dailybruin.com/images/2024/06/photo79.ZI_.jpg',
        description: "California Highway Patrol officers, many wearing gas masks, stand at the pathway between Powell Library and Kaplan Hall.",
        byline: '(Zoraiz Irshad/Daily Bruin senior staff)',
        date: '5/1',
        fulldate: 'May 1, 2024 2:51 a.m.',
        },
        {
        name: 'photo76',
        title: "California Highway Patrol lines up by flagpole",
        image: 'https://wp.dailybruin.com/images/2024/06/photo80.JC_.jpg',
        description: "CHP officers armed with batons and other less-than-lethal weapons stand by the flagpole in Dickson Plaza as protesters watch on from the side. During the sweep, law enforcement officers repeatedly used flash-bang devices, producing large booms throughout the night and early morning until at least 6:25 a.m.",
        byline: '(Jeremy Chen/Daily Bruin senior staff)',
        date: '5/1',
        fulldate: 'May 1, 2024 2:50 a.m.',
        },
        {
        name: 'photo77',
        title: "Clouds of gas at barriers",
        image: 'https://wp.dailybruin.com/images/2024/06/photo81.JC_.jpg',
        description: "A large cloud of gas covers one side of the encampment barrier. Over the several hours of attacks, the encampment was bombarded with tear gas, pepper spray and various noxious gasses.",
        byline: '(Jeremy Chen/Daily Bruin senior staff)',
        date: '5/1',
        fulldate: 'May 1, 2024 12:21 a.m.',
        },
        {
        name: 'photo78',
        title: "Eye irritants used on encampment participants",
        image: 'https://wp.dailybruin.com/images/2024/06/photo82.JC_.jpg',
        description: "A pro-Palestine protester has an irritant washed out of their eyes. Throughout the night, many protesters were treated for eye irritation caused by pepper spray, tear gas or other irritants.",
        byline: '(Jeremy Chen/Daily Bruin senior staff)',
        date: '5/1',
        fulldate: 'May 1, 2024 1:05 a.m.',
        },
        {
        name: 'photo79',
        title: "Encampment participants protect barriers",
        image: 'https://wp.dailybruin.com/images/2024/06/photo83.JC_.jpg',
        description: "While counter-protesters continue to tear down the barriers, protesters inside the encampment attempt to stop the attackers' advances. Protesters tried to hold onto barricades as aggressors pulled them away.",
        byline: '(Jeremy Chen/Daily Bruin senior staff)',
        date: '5/1',
        fulldate: 'May 1, 2024 12:43 a.m.',
        },
        {
        name: 'photo80',
        title: "Staredown at barricade",
        image: 'https://wp.dailybruin.com/images/2024/06/photo84.JC_.jpg',
        description: "Counter-protesters stand a few yards away from the encampment barriers as a liquid is sprayed from inside the encampment. One of the counter-protesters holds a flag with \"Moshiach\" – the Hebrew word for \"the anointed one\" – on it, referring to the Messiah in Judaism.",
        byline: '(Jeremy Chen/Daily Bruin senior staff)',
        date: '5/1',
        fulldate: 'May 1, 2024 1:17 a.m.',
        },
        {
        name: 'photo81',
        title: "Law enforcement prepares for clearing out",
        image: 'https://wp.dailybruin.com/images/2024/06/photo85.JC_.jpg',
        description: "Law enforcement officers line up in Dickson Plaza just before 3 a.m. before clearing out the remaining counter-protesters.",
        byline: '(Jeremy Chen/Daily Bruin senior staff)',
        date: '5/1',
        fulldate: 'May 1, 2024 2:57 a.m.',
        },
        {
        name: 'photo82',
        title: "Pro-Palestine protester kneels in front of CHP",
        image: 'https://wp.dailybruin.com/images/2024/06/photo86.JC_.jpg',
        description: "A pro-Palestine protester kneels in front of two California Highway Patrol officers with their head in their hands.",
        byline: '(Jeremy Chen/Daily Bruin senior staff)',
        date: '5/1',
        fulldate: 'May 1, 2024 3:06 a.m.',
        },
        {
        name: 'photo83',
        title: "Encampment braces for sweep",
        image: 'https://wp.dailybruin.com/images/2024/06/photo87.BJM_.jpg',
        description: "Pro-Palestine protesters link arms on Janss Steps as thousands came to show support for the encampment and brace for the ensuing police sweep. Around 3 p.m., encampment organizers held a press conference at the bottom of Janss Steps.",
        byline: '(Brandon Morquecho/Daily Bruin senior staff)',
        date: '5/1',
        fulldate: 'May 1, 2024 4:41 p.m.',
        },
        {
        name: 'photo84',
        title: "Law enforcement in Haines Hall",
        image: 'https://wp.dailybruin.com/images/2024/06/photo88.BJM_.jpg',
        description: "Law enforcement officers fiIe into Haines Hall around 9:30 p.m. as protesters in support of the encampment shouted, \"Shame\"",
        byline: '(Brandon Morquecho/Daily Bruin senior staff)',
        date: '5/1',
        fulldate: 'May 1, 2024 9:27 p.m.',
        },
        {
        name: 'photo85',
        title: "Rebuilding barriers",
        image: 'https://wp.dailybruin.com/images/2024/06/photo89.BJM_.jpg',
        description: "Recovering from the counter-protesters' violent attacks on the encampment, members of the encampment spend time rebuilding the barriers torn down the night before.",
        byline: '(Brandon Morquecho/Daily Bruin senior staff)',
        date: '5/1',
        fulldate: 'May 1, 2024 12:34 p.m.',
        },
        {
        name: 'photo86',
        title: "Law enforcement gathers in Wilson Plaza",
        image: 'https://wp.dailybruin.com/images/2024/06/photo90.ZL_.jpg',
        description: "Law enforcement vehicles gather in Wilson Plaza ahead of the following sweep. Several different departments began amassing Wednesday afternoon, including officers from the California Highway Patrol, Los Angeles County Sheriff's Department, UCPD, LAPD and the Santa Monica Police Department. The cars began leaving Wilson Plaza shortly before 8 p.m.",
        byline: '(Zimo Li/Photo Editor)',
        date: '5/1',
        fulldate: 'May 1, 2024 5:41 p.m.',
        },
        {
        name: 'photo87',
        title: "Volunteer medics",
        image: 'https://wp.dailybruin.com/images/2024/06/photo91.ADL_.jpg',
        description: "Volunteer medics set up an aid station in preparation for the following morning's sweep. These medics, which included pre-medical students and UCLA physicians alike, helped provide immediate medical care to those injured during the violence of April 30 and May 2.",
        byline: '(Anna Dai-Liu/Daily Bruin senior staff)',
        date: '5/1',
        fulldate: 'May 1, 2024 5:45 p.m.',
        },
        {
        name: 'photo88',
        title: "Police group in Dickson Plaza",
        image: 'https://wp.dailybruin.com/images/2024/06/photo92.JC_.jpg',
        description: "Police officers form a line in Dickson Plaza facing the encampment. Earlier that day, law enforcement had placed barriers along the eastern entrance to the plaza by the flagpole. ",
        byline: '(Jeremy Chen/Daily Bruin senior staff)',
        date: '5/1',
        fulldate: 'May 1, 2024 6:19 p.m.',
        },
        {
        name: 'photo89',
        title: "Protesters atop scaffolding",
        image: 'https://wp.dailybruin.com/images/2024/06/photo93.ZI_.jpg',
        description: "Several members of the encampment stand atop scaffolding by Powell Library on May 1. The day before, UCPD detained a protester who climbed the scaffolding before releasing them a little over an hour later. ",
        byline: '(Zoraiz Irshad/Daily Bruin senior staff)',
        date: '5/1',
        fulldate: 'May 1, 2024 6:44 p.m.',
        },
        {
        name: 'photo90',
        title: "LAPD officers at Janss Steps",
        image: 'https://wp.dailybruin.com/images/2024/06/photo94.BJM_.jpg',
        description: "Four LAPD officers in riot gear stand at the top of Janss Steps while pro-Palestine protesters film them.",
        byline: '(Brandon Morquecho/Daily Bruin senior staff)',
        date: '5/2',
        fulldate: 'May 2, 2024 1:53 a.m.',
        },
        {
        name: 'photo91',
        title: "LAPD officer drags pro-Palestine protester",
        image: 'https://wp.dailybruin.com/images/2024/06/photo95.BJM_.jpg',
        description: "An LAPD officer drags a pro-Palestine protester by the back of their hoodie as law enforcement engage with members of the encampment.",
        byline: '(Brandon Morquecho/Daily Bruin senior staff)',
        date: '5/2',
        fulldate: 'May 2, 2024 1:22 a.m.',
        },
        {
        name: 'photo92',
        title: "Officers await instructions",
        image: 'https://wp.dailybruin.com/images/2024/06/photo96.BJM_.jpg',
        description: "Several law enforcement officers stand in front of the encampment's barrier while both law enforcement and protesters wait for the sweep to begin. ",
        byline: '(Brandon Morquecho/Daily Bruin senior staff)',
        date: '5/2',
        fulldate: 'May 2, 2024 1:37 a.m.',
        },
        {
        name: 'photo93',
        title: "Riot gear and zip tie handcuffs",
        image: 'https://wp.dailybruin.com/images/2024/06/photo97.JC_-1.jpg',
        description: "Officers wearing riot gear group by the southwestern corner of Haines Hall, equipped with zip tie handcuffs and batons at the ready. ",
        byline: '(Jeremy Chen/Daily Bruin senior staff)',
        date: '5/2',
        fulldate: 'May 2, 2024 3:04 a.m.',
        },
        {
        name: 'photo94',
        title: "Officers by Student Activities Center",
        image: 'https://wp.dailybruin.com/images/2024/06/photo98.JCC_.jpg',
        description: "A group of law enforcement officers stands on a path between the Student Activities Center and the lawn south of Janss Steps. The officers proceeded to regroup in Wilson Plaza before being called away.",
        byline: '(Joseph Crosby/Daily Bruin senior staff)',
        date: '5/2',
        fulldate: 'May 2, 2024 1:51 a.m.',
        },
        {
        name: 'photo95',
        title: "Protesters remain on Janss Steps",
        image: 'https://wp.dailybruin.com/images/2024/06/photo99.JCC_.jpg',
        description: "Hundreds of protesters remained on Janss Steps through the early hours of May 2. Many protesters wore goggles and helmets in anticipation of violence from the police.",
        byline: '(Joseph Crosby/Daily Bruin senior staff)',
        date: '5/2',
        fulldate: 'May 2, 2024 2:00 a.m.',
        },
        {
        name: 'photo96',
        title: "Protester overturns trash cans",
        image: 'https://wp.dailybruin.com/images/2024/06/photo100.ZL_.jpg',
        description: "A protester turnestrash cans on their sides, creating more obstacles for law enforcement to traverse before entering the encampment.",
        byline: '(Zoraiz Irshad/Daily Bruin senior staff)',
        date: '5/2',
        fulldate: 'May 2, 2024 3:08 a.m.',
        },
        {
        name: 'photo97',
        title: "Los Angeles County Sheriff's Department buses assemble",
        image: 'https://wp.dailybruin.com/images/2024/06/photo101.MF_-1.jpg',
        description: "Los Angeles County Sheriff's Department buses assemble on Royce Drive. By the end of the night, over 200 protesters had been detained. The first detainment, as reported by the Daily Bruin, took place around 2 a.m.",
        byline: '(Myka Fromm/Daily Bruin senior staff)',
        date: '5/2',
        fulldate: 'May 2, 2024 2:59 a.m.',
        },
        {
        name: 'photo98',
        title: "Stand-off at the Inverted Fountain",
        image: 'https://wp.dailybruin.com/images/2024/06/photo102.NG_.jpeg',
        description: "Police wearing riot gear and carrying less-than-lethal weapons face a crowd of protesters early Thursday morning near the Inverted Fountain. As protesters chanted together, the police slowly advanced their lines. Ultimately, however, a physical confrontation was avoided, and both groups departed in opposite directions.",
        byline: '(Nicolas Greamo/Daily Bruin senior staff)',
        date: '5/2',
        fulldate: 'May 2, 2024 6:39 a.m.',
        },
        {
        name: 'photo99',
        title: "Last encampment holdouts",
        image: 'https://wp.dailybruin.com/images/2024/06/photo103.NG_.jpg',
        description: "At 6 a.m., a small group of protesters remain at the top of Janss Steps, chanting in unison.",
        byline: '(Nicolas Greamo/Daily Bruin senior staff)',
        date: '5/2',
        fulldate: 'May 2, 2024 7:10 a.m.',
        },
        {
        name: 'photo100',
        title: "Chants in late morning",
        image: 'https://wp.dailybruin.com/images/2024/06/photo104.NG_.jpg',
        description: "The remaining protesters stand face-to-face with California Highway Patrol officers. After over an hour of chanting, the last of the protesters left the area.",
        byline: '(Nicolas Greamo/Daily Bruin senior staff)',
        date: '5/2',
        fulldate: 'May 2, 2024 7:19 a.m.',
        },
        {
        name: 'photo101',
        title: "Encampment in ruin",
        image: 'https://wp.dailybruin.com/images/2024/06/photo105.NG_.jpg',
        description: "Remnants of the encampment barricade are left strewn about the ground of Dickson Plaza. Almost nothing from the encampment remained intact.",
        byline: '(Nicolas Greamo/Daily Bruin senior staff)',
        date: '5/2',
        fulldate: 'May 2, 2024 7:44 a.m.',
        },
  // {
  //   name: 'photo',
  //   title: '',
  //   image: '',
  //   description: "",
  //   byline: "",
  //   date: "",
  //   fulldate: "May 1, 2024"
  // },

]

function Popup(props) {
    console.log(props)
  return (props.trigger) ? (
    <div className="popup">
      <div className="popup-inner">
        <div className="fulldate">
          {content[props.popupTitle].fulldate}
        </div>
        <h2 style={{ marginTop: 2 }}>{content[props.popupTitle].title}</h2>
        <img src={content[props.popupTitle].image} alt='altText' width="100%" height="100%" />
        <br />
        <p style={{ marginTop: "10px", lineHeight: "130%" }}> {content[props.popupTitle].description} </p>
        <div className='byline'>
          {content[props.popupTitle].byline}
        </div>
        <div className='close-btn' onClick={() => props.setTrigger(false)}>
          <svg xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 -960 960 960"
            width="24px"
            fill="#000000"
            alt='Close'>
            <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" /></svg>
        </div>
        {props.children}
      </div>
    </div>
  ) : "";
}

export default Popup